import Navbar from "../navbar";
import Sidebar from "../sidebar";
import React from "react";
import './style.css'

export default function Layout(props) {
    return (
        <React.Fragment>
            <div className="app-layout">
                <Navbar />
                <Sidebar />
                <div className="main">
                    {props.children}
                </div>
            </div>
        </React.Fragment>
    )
}